
import './EnvelopeNote.css';
import stickers from '../assets/constants/stickers.js' 
import React, {useState} from "react";

function EnvelopeNote(props) {

    // const [expandedView, setExpandedView] = useState(false)
    const [showNote, setShowNote] = useState(false)

    // let envelopeNoteClassName=expandedView ? "noteOnPaper noteOnPaperExpanded" : "noteOnPaper"
    return (
        <div className="envelopeNote">
            <div onClick={() => setShowNote(true)} className="envelopeNoteBox">
                <div className="envelopeNoteBoxLeftLine"></div>
                <div className="envelopeNoteBoxRightLine"></div>
                <img className="envelopeSticker" src={stickers[props.sticker].src} alt={stickers[props.sticker].alt} />
            </div>
            {showNote &&
                <div className="noteOnPaper">
                    <p className="closeNoteText" onClick={()=>setShowNote(false)}> close note</p>
                    <p className="envelopeNotePersonText"> dear {props.to},</p>
                    <p className="envelopeNoteBodyText">{props.note}</p>
                    <p className="envelopeNotePersonText"> sincerely, {props.from}</p>
                    <img className="envelopeSticker" src={stickers[props.sticker].src} alt={stickers[props.sticker].alt} />
                </div>

            }
            {!showNote &&
            <p className="clickNote"> click the envelope to open a note!</p>
            }
        </div>
    )
}

export default EnvelopeNote;